/* msd-busqueda-exacta.js — que la búsqueda sume las palabras en vez de mezclarlas.

   EL PROBLEMA (05/09/2026). Buscar `cable red 5m` en la tienda devolvía de todo: cables
   USB, HDMI, latiguillos RJ11. Shopify empareja con CUALQUIERA de las palabras, y la
   relevancia lo disimula… hasta que ordenas por precio, y entonces suben los más baratos
   del millar que casan de refilón. Medido en el catálogo real:

       cable red 5m            1000 resultados, por precio salían cables de 0,25 m y USB
       "cable" "red" "5m"        61 resultados, todos cables de red de 5 metros

   Entrecomillar CADA palabra por separado obliga a Shopify a exigirlas todas. Entre
   comillas la palabra se busca exacta, sin expansión difusa.

       brother tn2420       207  ->  4
       impresora epson wifi 1000 -> 32
       hp 305xl               23 ->  5

   LA RED DE SEGURIDAD, y es la pieza importante. La coincidencia exacta puede quedarse
   corta —tildes, plurales, una palabra que el catálogo escribe de otra forma— y una
   búsqueda con cero resultados es mucho peor que una con ruido. Así que si la versión
   entrecomillada no encuentra nada, la página se recarga sola con la búsqueda de siempre
   y el cliente no se entera de nada.

   LO QUE NO TOCA: el autocompletado. El desplegable de sugerencias ya acierta —usa otro
   motor— y se queda como está. Esto solo actúa al ENVIAR el formulario.
*/
(function () {
  "use strict";

  var MARCA = "msd_ex";          // dice que la consulta ya la reescribimos nosotros
  var VUELTA = "msd_ex_no";      // dice que ya se intentó y no hubo resultados

  function entrecomillar(texto) {
    var partes = String(texto || "").trim().split(/\s+/).filter(Boolean);
    if (partes.length === 0) return null;
    // Si el cliente ya usa comillas, es que sabe lo que hace: no se toca.
    if (String(texto).indexOf('"') !== -1) return null;
    // Una sola palabra no necesita ayuda: no hay nada que sumar, y entrecomillarla solo
    // le quitaría la búsqueda por prefijo, que ahí sí es útil.
    if (partes.length === 1) return null;
    return unir(partes).map(termino).join(" ");
  }

  // Si el cliente separa el numero de la unidad —«cable red 5 m»— se vuelven a juntar.
  // Suelto, ese `m` es una unidad suelta que casa con medio catalogo: de las 48 primeras
  // fichas solo 18 eran de 5 metros. Unido, 48 de 48.
  //
  // OJO, esto NO se hace al reves. El catalogo tiene 153 fichas (0,6%) que escriben la
  // medida separada —«2.0 m»— y probamos a buscarlas tambien asi: Shopify no respeta la
  // frase entrecomillada con espacio, y `"2.0 m"` colaba «HDMI 2.0/M». Los resultados se
  // doblaban y la mitad era ruido. Para esas 153 la solucion es arreglar el titulo, no
  // la busqueda.
  var UNIDADES = /^(m|cm|mm|metros?|cms?)$/i;
  function unir(partes) {
    var r = [];
    for (var i = 0; i < partes.length; i++) {
      if (i + 1 < partes.length &&
          /^\d+(?:[.,]\d+)?$/.test(partes[i]) &&
          UNIDADES.test(partes[i + 1])) {
        // «metros» y «cms» se normalizan a como lo escribe el catalogo
        var u = partes[i + 1].toLowerCase().replace(/^metros?$/, "m").replace(/^cms?$/, "cm");
        r.push(partes[i] + u);
        i++;
      } else {
        r.push(partes[i]);
      }
    }
    return r;
  }

  // Coma o punto decimal, da igual cual escriba el cliente. `cable usb 0,5m` y
  // `cable usb 0.5m` devolvian cosas distintas —3 fichas contra 30— porque el catalogo
  // escribe la medida de las dos formas segun el proveedor. Se buscan LAS DOS:
  //
  //     "cable" "1,5m"                    5 fichas
  //     "cable" "1.5m"                  222
  //     "cable" ("1,5m" OR "1.5m")      223   <- la union, que es lo que se quiere
  //
  // El OR va en MAYUSCULAS: en minusculas Shopify lo toma como una palabra mas y
  // devuelve cero. Solo se expande un separador entre digitos: `1,5m` si, pero una
  // referencia como `A133-0181` o un `1.000,50` se dejan tal cual.
  function termino(p) {
    var m = p.match(/^(\d+)([.,])(\d.*)$/);
    if (!m) return '"' + p + '"';
    var otro = m[2] === "," ? "." : ",";
    return '("' + m[1] + m[2] + m[3] + '" OR "' + m[1] + otro + m[3] + '")';
  }

  // ---- 1) al enviar el formulario, se manda la versión entrecomillada ----
  document.addEventListener("submit", function (ev) {
    var form = ev.target;
    if (!form || form.getAttribute("role") !== "search") return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    // ORDEN POR DEFECTO: lo mas barato que este en stock.
    //
    // VA LO PRIMERO, y esto costo un fallo en produccion. Estaba mas abajo, detras del
    // `return` que descarta las busquedas que no hay que entrecomillar, asi que una
    // palabra suelta —«macbook»— salia por ahi y se quedaba sin ordenar. Entrecomillar
    // solo tiene sentido con varias palabras; ordenar tiene sentido SIEMPRE.
    //
    // El filtro NO es el nativo de Shopify. Esta tienda tiene el inventario nativo
    // desactivado a proposito y el stock vive en el metacampo `custom.disponibilidad`,
    // asi que `filter.v.availability` no hace absolutamente nada aqui: lo probe y
    // devolvia los mismos 61 resultados.
    //
    // Solo se ponen si el cliente no ha elegido ya: en cuanto toca el desplegable de
    // orden o un filtro, manda el suyo y esto no vuelve a meterse.
    // SIN `sort_by` (09/10/2026). Esta linea era el cuarto sitio donde se forzaba el
    // orden por precio, y el unico que sobrevivio al arreglo de los formularios:
    // los tres <input> de Liquid se quitaron por la manana y la busqueda SEGUIA
    // saliendo mal, porque esto lo anade desde JavaScript al enviar. Gonzalo lo
    // vio probandolo en la tienda cuando yo ya habia dado el arreglo por bueno:
    // comprobar el formulario no es comprobar la URL que acaba pidiendo.
    //
    // La busqueda de Shopify es SEMANTICA -de 96 resultados de «trackball» solo 17
    // llevan la palabra- y el orden por relevancia es lo UNICO que separa el
    // trackball de cualquier raton. Con precio ascendente salian alfombrillas de 2 EUR.
    // El filtro de disponibilidad de la linea siguiente SI se queda: ese no estorba.
    poner(form, "filter.p.m.custom.disponibilidad", "Disponible");

    var nueva = entrecomillar(input.value);
    if (!nueva) return;
    // El texto que escribió el cliente viaja aparte para poder volver a él si hace falta
    // y para pintarlo tal cual en la caja de la página de resultados.
    if (!form.querySelector('input[name="' + MARCA + '"]')) {
      var h = document.createElement("input");
      h.type = "hidden"; h.name = MARCA; h.value = input.value;
      form.appendChild(h);
    }
    input.value = nueva;
  }, true);

  function poner(form, nombre, valor) {
    if (form.querySelector('[name="' + nombre + '"]')) return;
    var h = document.createElement("input");
    h.type = "hidden"; h.name = nombre; h.value = valor;
    form.appendChild(h);
  }

  // ---- 3) el desplegable de sugerencias ----
  //
  // La API de sugerencias no admite orden ni filtro: devuelve por relevancia y su campo
  // `available` viene `true` en TODO el catalogo —otra vez el inventario nativo
  // desactivado—, asi que no sirve para saber si hay stock. Lo que si sirve es el
  // marcado que ya pinta el tema en cada sugerencia: `.msd-si--ok` / `.msd-si--no`
  // para el stock y `.msd-si-precio` para el precio. Con eso se reordena aqui mismo.
  //
  // Primero lo que esta en stock, y dentro de cada grupo lo mas barato. Los agotados
  // no se esconden: se van al final. En el desplegable caben pocas sugerencias y
  // quitarlas del todo dejaria busquedas sin ninguna.
  function precioDe(li) {
    var e = li.querySelector(".msd-si-precio");
    if (!e) return Infinity;
    var n = e.textContent.replace(/[^\d.,]/g, "").replace(/\./g, "").replace(",", ".");
    var v = parseFloat(n);
    return isNaN(v) ? Infinity : v;
  }

  function ordenarSugerencias(lista) {
    var items = Array.prototype.slice.call(
      lista.querySelectorAll(":scope > li"));
    if (items.length < 2) return;
    var clave = referenciaEscrita();
    var escrito = textoEscrito();
    var datos = items.map(function (li, i) {
      var txt = (li.textContent || "").toLowerCase().replace(/[^a-z0-9]/g, "");
      // El TITULO solo, no el `li` entero: ahi dentro van tambien el proveedor, el stock y
      // el precio, y «empieza por» no significa nada medido sobre ese revoltijo.
      var h = li.querySelector(".predictive-search__item-heading");
      var tit = ((h && h.textContent) || "").toLowerCase().replace(/[^a-z0-9]/g, "");
      return {
        li: li,
        exacto: (clave && txt.indexOf(clave) !== -1) ? 0 : 1,
        empieza: (escrito && tit.indexOf(escrito) === 0) ? 0 : 1,
        sinStock: li.querySelector(".msd-si--no") ? 1 : 0,
        precio: precioDe(li),
        orden: i                       // desempata por relevancia, la que traia
      };
    });
    var ya = datos.every(function (d, i) {
      return i === 0 || comparar(datos[i - 1], d) <= 0;
    });
    if (ya) return;                    // ya estaba ordenado: no se toca el DOM
    datos.sort(comparar);
    var frag = document.createDocumentFragment();
    datos.forEach(function (d) { frag.appendChild(d.li); });
    lista.appendChild(frag);
  }

  // LA COINCIDENCIA EXACTA MANDA SOBRE EL STOCK (06/09/2026). Poner los agotados al final
  // esta bien cuando compites entre articulos parecidos, pero rompia el caso mas util:
  // al escribir «brother tzefx641» el articulo buscado salia el 1o de la API y mi orden
  // lo mandaba al puesto 8, debajo de ocho impresoras que si tenian stock. Quien teclea
  // una referencia entera quiere ESA ficha, tenga stock o no; ya se le avisa con su
  // etiqueta roja de «Sin stock». Asi que primero lo que casa con la referencia escrita,
  // y dentro de cada grupo, lo disponible y lo mas barato.
  function comparar(a, b) {
    return (a.exacto - b.exacto) || (a.empieza - b.empieza) ||
           (a.sinStock - b.sinStock) ||
           (a.precio - b.precio) || (a.orden - b.orden);
  }

  // La palabra larga que ha escrito el cliente: una referencia, no «brother» ni «cinta».
  // Se queda con la mas larga de 5 o mas letras y con algun numero dentro, que es como
  // son las referencias. Si no hay ninguna, no se aplica nada y todo sigue igual.
  // Todo lo escrito, junto y sin signos: «hp 305» -> «hp305». Sirve para saber si un
  // titulo EMPIEZA por lo que el cliente lleva tecleado.
  //
  // De cuatro caracteres para abajo no se usa: con «hp» empezarian por ahi todos los
  // articulos de HP y el criterio no separaria nada, solo añadiria ruido.
  function textoEscrito() {
    var caja = document.querySelector('form[role="search"] input[name="q"]');
    var t = (caja && caja.value ? caja.value : "").toLowerCase().replace(/[^a-z0-9]/g, "");
    return t.length >= 4 ? t : "";
  }

  function referenciaEscrita() {
    var caja = document.querySelector('form[role="search"] input[name="q"]');
    if (!caja || !caja.value) return "";
    var mejor = "";
    caja.value.toLowerCase().split(/[^a-z0-9]+/).forEach(function (w) {
      // 4 y no 5 (06/09): escribiendo `fx64` la FX641 salia la quinta, debajo de cuatro
      // cintas que solo comparten familia. Cuatro caracteres con letra y numero ya son
      // una referencia a medias, y lo que casa con ella debe subir.
      if (w.length >= 4 && /[0-9]/.test(w) && /[a-z]/.test(w) && w.length > mejor.length) {
        mejor = w;
      }
    });
    return mejor;
  }

  // El desplegable se repinta con cada tecla, asi que hay que reordenar cada vez.
  var obs = new MutationObserver(function () {
    var lista = document.querySelector("#predictive-search-results-products-list");
    if (lista) ordenarSugerencias(lista);
  });
  document.addEventListener("DOMContentLoaded", function () {
    obs.observe(document.body, { childList: true, subtree: true });
  });

  // ---- 3 bis) la PAGINA de resultados, con la misma regla que el desplegable ----
  //
  // Ver la cabecera del fichero: el desplegable ya ponia delante lo que empieza por lo
  // escrito, y la pagina de resultados se habia quedado fuera.
  function escritoDeLaUrl() {
    var m = /[?&]q=([^&]*)/.exec(window.location.search);
    if (!m) return "";
    var t = decodeURIComponent(m[1].replace(/\+/g, " "))
      .toLowerCase().replace(/[^a-z0-9]/g, "");
    return t.length >= 4 ? t : "";
  }

  function ordenarResultados() {
    if (window.location.pathname.indexOf("/search") !== 0) return;
    var escrito = escritoDeLaUrl();
    if (!escrito) return;
    // `#product-grid` NO es lo mismo en los dos sitios: en una coleccion ES la lista,
    // y en la pagina de busqueda es un DIV que la envuelve. Buscar `:scope > li` sobre el
    // div devolvia cero y la pagina se quedaba sin ordenar, en silencio.
    var caja = document.querySelector("#product-grid");
    if (!caja) return;
    var rejilla = caja.tagName === "UL" ? caja : caja.querySelector("ul.product-grid, ul.grid");
    if (!rejilla) return;
    // Solo las fichas con producto: la rejilla trae ademas algun `li` de relleno, y
    // moverlos con los demas los sacaria de su sitio.
    var items = Array.prototype.slice.call(rejilla.querySelectorAll(":scope > li"))
      .filter(function (li) { return li.querySelector('a[href*="/products/"]'); });
    if (items.length < 2) return;
    var delante = [], detras = [], cambia = false, visto = false;
    items.forEach(function (li) {
      var h = li.querySelector(".card__heading, .card-information__text, h3");
      var tit = ((h && h.textContent) || "").toLowerCase().replace(/[^a-z0-9]/g, "");
      if (tit.indexOf(escrito) === 0) {
        if (visto) cambia = true;          // uno bueno DESPUES de uno que no lo era
        delante.push(li);
      } else {
        visto = true;
        detras.push(li);
      }
    });
    if (!cambia || !delante.length) return;  // ya estaba bien: no se toca el DOM
    var frag = document.createDocumentFragment();
    delante.concat(detras).forEach(function (li) { frag.appendChild(li); });
    rejilla.appendChild(frag);
  }

  document.addEventListener("DOMContentLoaded", ordenarResultados);
  // La rejilla se repinta al filtrar o al paginar, asi que hay que volver a ordenar.
  var obsRes = new MutationObserver(function () { ordenarResultados(); });
  document.addEventListener("DOMContentLoaded", function () {
    var cont = document.querySelector("#ProductGridContainer");
    if (cont) obsRes.observe(cont, { childList: true, subtree: true });
  });

  // ---- 4) el guion a medio escribir ----
  //
  // EL PROBLEMA (Gonzalo, 05/09/2026): escribiendo `mfc-j4` no aparecia NADA en el
  // desplegable. Medido contra el catalogo:
  //
  //     mfc-j4        0        mfcj4        4
  //     mfc-j4540     0        mfcj4540     1
  //     mfc-j4540dw   6        <- el modelo COMPLETO si funciona
  //
  // Con guion, Shopify deja de buscar por prefijo y exige el termino entero. Escribiendo
  // a medias eso es siempre cero. Sin guion, el prefijo vuelve a funcionar.
  //
  // NO se quita el guion siempre: `a133-0181` (referencia de AISENS) encuentra su ficha
  // con guion y ninguna sin el. Asi que primero se busca lo que escribio el cliente y
  // SOLO si no hay nada se reintenta sin guiones. Nunca quita resultados; solo rellena
  // huecos.
  //
  // Tampoco se usa el truco del OR aqui: en las sugerencias Shopify no lo trata como
  // operador sino como una palabra mas, y el prefijo «OR» casa con «Oro Rosa». Salia un
  // Apple Watch al buscar impresoras.
  var CON_GUION = /[a-z0-9]-[a-z0-9]/i;

  function sinGuiones(s) { return String(s).replace(/-/g, ""); }

  // ---- 5) la COLA de la referencia ----
  //
  // EL PROBLEMA (Gonzalo, 06/09/2026): escribiendo `fx641` o `fx631` no salia nada,
  // aunque tenemos las dos cintas. Shopify empareja SOLO desde el principio de la
  // palabra: `tzefx641` encuentra la ficha y `fx641` no, porque va por el medio.
  // Y la gente teclea la cola, que es como llama Brother a la cinta.
  //
  //     fx641      0          tzefx641   1
  //     fx631      0          tzefx631   1
  //     zefx641    0          <- ni siquiera vale acercarse
  //
  // No hay busqueda por subcadena en Shopify, asi que se prueba a devolverle la cabeza:
  // si la cola no da nada, se repite pidiendo PREFIJO+cola para los prefijos de
  // referencia que existen en este catalogo. Los prefijos salen de contar los SKU
  // activos, no de una lista inventada: EQ 841, TK 248, LC 193, TN 149, CF 142... y TZE,
  // que es el de las cintas.
  //
  // Las candidatas van separadas por espacios y NO entre comillas: en las sugerencias
  // Shopify une varias palabras con O, que es justo lo que interesa aqui. Puede colar
  // algo de ruido, pero el orden del desplegable ya sube al primer puesto lo que casa
  // con lo escrito, asi que el ruido se queda debajo. Y solo entra cuando el resultado
  // era CERO: nunca quita nada, solo rellena.
  // MEDIDO ANTES DE ELEGIR ESTO, y corregido el 06/09 con `fx64` a medio escribir:
  //
  //     fx64 tzefx64 tnfx64 ......... 0     varias cabezas juntas: nada
  //     fx64* tzefx64* tnfx64* ...... 0     ni con asterisco, si van juntas
  //     tzefx64* .................... 7     UNA sola, con asterisco: las cintas
  //
  // O sea que hay que probarlas DE UNA EN UNA y con asterisco, porque la cola tambien
  // llega a medias —`fx64` antes de acabar de teclear el `1`— y sin asterisco Shopify
  // no expande el prefijo. Se para en la primera que traiga algo. Son peticiones de
  // solo lectura y cortas, y solo ocurren cuando el desplegable esta vacio, que es
  // cuando el cliente no esta viendo nada de todas formas.
  // ---- 6) el asterisco: la referencia a medio escribir ----
  //
  // EL PROBLEMA (Gonzalo, 06/09/2026): escribiendo `tn251` el desplegable ensenaba los
  // tres originales de Brother y NO el generico, que es el que interesa vender —21,39 EUR
  // frente a 54,91—. El generico si aparecia en la pagina de resultados, o sea que la
  // ficha esta bien: es el buscador de sugerencias, que es un indice aparte y mas estricto
  // que el de la pagina.
  //
  // El asterisco lo arregla, porque obliga a Shopify a expandir el prefijo:
  //
  //     tn251     3 fichas        tn251*     6   <- entran los genericos
  //     tn2510    3               tn2510*    6
  //     tn2420    5               tn2420*   10
  //     tzefx641  1               tzefx641*  7
  //
  // PERO SOLO CON UNA PALABRA SUELTA. Medido tambien lo que estropea:
  //
  //     hp 305xl        10 fichas  ->  5 con asterisco (pierde la mitad)
  //     portatil asus   portatiles ->  baterias y cargadores primero
  //
  // Y NI SIQUIERA SIEMPRE CON UNA SOLA PALABRA (Gonzalo, 06/09, con `lc422`). El limite
  // del desplegable son 10 fichas, asi que si el asterisco amplia la busqueda, lo que
  // entra empuja fuera a lo que ya estaba:
  //
  //     lc422    9 fichas, con los CUATRO genericos de 16-17 EUR
  //     lc422*  10 fichas, con UNO solo: los otros tres se caen por el limite
  //
  // Por eso el asterisco no se usa a ciegas: primero se pide lo escrito tal cual, y solo
  // si trae poca cosa se prueba a ampliar. Con `tn251` (3 fichas) amplia y gana los
  // genericos; con `lc422` (9) se queda como esta.
  var POCAS = 6;

  function cuantas(html) {
    return (html.split("predictive-search__item-heading").length - 1);
  }
  //
  // Asi que se aplica unicamente cuando lo escrito es UNA referencia: letras pegadas a
  // numeros y sin espacios. Y si el asterisco se queda sin nada, se vuelve a lo escrito.
  var REFERENCIA = /^[a-z]{1,6}[0-9][a-z0-9]*$/i;

  function conAsterisco(texto) {
    var t = String(texto).trim();
    return REFERENCIA.test(t) ? t + "*" : "";
  }

  var PREFIJOS = ["tze", "tn", "lc", "cf", "tk", "crg"];
  var COLA_REF = /^[a-z]{1,4}[0-9]{2,6}[a-z]{0,3}$/i;

  function candidatas(texto) {
    var t = String(texto).trim().toLowerCase();
    if (!COLA_REF.test(t)) return [];
    return PREFIJOS.filter(function (p) {
      return t.indexOf(p) !== 0;
    }).map(function (p) {
      return p + t + "*";
    });
  }

  var fetchOriginal = window.fetch;
  if (typeof fetchOriginal === "function") {
    window.fetch = function (entrada, opciones) {
      var url = typeof entrada === "string" ? entrada : (entrada && entrada.url) || "";
      if (url.indexOf("/search/suggest") === -1) {
        return fetchOriginal.apply(this, arguments);
      }
      var q = (url.match(/[?&]q=([^&]*)/) || [])[1];
      var texto = q ? decodeURIComponent(q.replace(/\+/g, " ")) : "";
      // el reintento sirve para dos cosas: quitar el guion, o devolverle la cabeza a la
      // referencia. Se elige aqui cual toca, y si no toca ninguna no se envuelve nada.
      var intentos = [];
      var estrella = texto ? conAsterisco(texto) : "";
      if (texto && CON_GUION.test(texto)) intentos = [sinGuiones(texto)];
      else if (texto) intentos = candidatas(texto);
      // si la referencia admite asterisco, esa es la consulta buena y va la PRIMERA;
      // lo escrito tal cual queda de red de seguridad al final de la fila.
      // orden de la fila: lo escrito con asterisco, luego las cabezas, y por ultimo
      // lo escrito tal cual, que es lo que pedia el tema.
      if (estrella) intentos = [estrella].concat(candidatas(texto), [texto]);
      if (!intentos.length) {
        return fetchOriginal.apply(this, arguments);
      }
      if (estrella) {
        var self0 = this, args0 = arguments;
        var conQ = function (q) {
          return url.replace(/([?&]q=)[^&]*/, "$1" + encodeURIComponent(q));
        };
        // las cabezas, de una en una, para cuando no hay absolutamente nada
        var cabezas = candidatas(texto);
        var porCabezas = function (i) {
          if (i >= cabezas.length) return null;
          return fetchOriginal.call(self0, conQ(cabezas[i]), args0[1]).then(function (r) {
            if (!r.ok) return porCabezas(i + 1);
            return r.clone().text().then(function (h) {
              return cuantas(h) ? r : porCabezas(i + 1);
            });
          }, function () { return porCabezas(i + 1); });
        };
        return fetchOriginal.apply(self0, args0).then(function (resp0) {
          if (!resp0.ok) return resp0;
          return resp0.clone().text().then(function (h0) {
            var n0 = cuantas(h0);
            if (n0 >= POCAS) return resp0;            // ya trae de sobra: no se toca
            return fetchOriginal.call(self0, conQ(estrella), args0[1]).then(
              function (r1) {
                if (!r1.ok) return n0 ? resp0 : (porCabezas(0) || resp0);
                return r1.clone().text().then(function (h1) {
                  if (cuantas(h1) > n0) return r1;    // el asterisco aporta: se queda
                  return n0 ? resp0 : (porCabezas(0) || resp0);
                });
              }, function () { return n0 ? resp0 : (porCabezas(0) || resp0); });
          });
        });
      }
      var args = arguments;
      var self = this;
      return fetchOriginal.apply(self, args).then(function (resp) {
        if (!resp.ok) return resp;
        return resp.clone().text().then(function (html) {
          // ¿trajo alguna ficha? si si, se devuelve tal cual
          if (html.indexOf("predictive-search__item-heading") !== -1) return resp;
          // se prueban las alternativas en fila; la primera que traiga fichas gana
          function probar(i) {
            if (i >= intentos.length) return Promise.resolve(resp);
            var otra = url.replace(/([?&]q=)[^&]*/,
                                   "$1" + encodeURIComponent(intentos[i]));
            return fetchOriginal.call(self, otra, args[1]).then(function (r) {
              if (!r.ok) return probar(i + 1);
              return r.clone().text().then(function (h) {
                if (h.indexOf("predictive-search__item-heading") === -1) {
                  return probar(i + 1);
                }
                return r;
              });
            }, function () { return probar(i + 1); });
          }
          return probar(0).then(function (r2) {
            // LA RESPUESTA SE DEVUELVE TAL CUAL. Hubo una version que reescribia el
            // HTML para que el boton «Buscar "..."» dijera el termino con guion, y fue
            // un error caro: era un reemplazo global sobre TODO el documento, y el
            // handle `mfcj5955dw` contiene la cadena `mfcj5`, asi que buscando `mfc-j5`
            // se convertia en `/products/mfc-j5955dw` — un 404. Enviaba clientes a una
            // pagina muerta.
            //
            // El boton se queda diciendo el termino sin guiones. Es una diferencia
            // cosmetica, y no rompe nada: la guarda de `updateSearchForTerm` en
            // predictive-search.js impide que el componente se atragante al compararlos.
            return r2.ok ? r2 : resp;
          });
        });
      });
    };
  }

  // ---- 2) en la página de resultados ----
  if (location.pathname.indexOf("/search") === -1) return;

  var par = new URLSearchParams(location.search);

  // 2z) el mismo problema del guion, pero al pulsar Enter. `mfc-j4` da cero resultados
  //     por lo mismo que en el desplegable, y una pagina vacia es lo peor que puede
  //     pasarle a una busqueda. Si no hay nada y la consulta lleva guion, se repite sin
  //     el. Una sola vez, que dos vacias seguidas serian un bucle.
  var SIN_GUION = "msd_sg";
  if (!par.get(SIN_GUION)) {
    var qbruta = par.get("q") || "";
    if (CON_GUION.test(qbruta)) {
      document.addEventListener("DOMContentLoaded", function () {
        var rej = document.querySelector("#product-grid");
        if (!rej || rej.querySelector("li")) return;   // hay resultados: nada que hacer
        par.set("q", sinGuiones(qbruta));
        par.set(SIN_GUION, "1");
        location.replace(location.pathname + "?" + par.toString());
      });
    }
  }

  // LA ESCALERA DE RESPALDO VA ANTES DEL GUARDIA DE `original`, y no es un detalle.
  // `msd_q` solo se anade cuando hubo algo que entrecomillar, o sea con dos palabras o
  // mas. Buscar una referencia suelta —«TZeFX641»— no lo lleva, asi que con la escalera
  // colgando del guardia el respaldo no saltaba justo en el caso mas comun.
  var paso = parseInt(par.get(VUELTA) || "0", 10);

  // Quita el filtro de stock de la URL. Son varios parametros con el mismo prefijo
  // —Shopify repite `filter.p.m.custom.disponibilidad` una vez por valor marcado—.
  function quitarFiltroStock(p) {
    var fuera = [], it = p.keys(), k;
    while (!(k = it.next()).done) {
      if (k.value.indexOf("filter.p.m.custom.disponibilidad") === 0) fuera.push(k.value);
    }
    fuera.forEach(function (n) { p.delete(n); });
    return fuera.length > 0;
  }

  // Un aviso discreto encima de la rejilla: el cliente tiene que saber que lo que ve
  // NO esta disponible ahora mismo. Sin esto, ensena agotados como si nada.
  function avisoSinStock(rejilla) {
    if (document.querySelector(".msd-aviso-stock")) return;
    var d = document.createElement("p");
    d.className = "msd-aviso-stock";
    d.setAttribute("role", "status");
    d.style.cssText = "margin:0 0 1.2rem;padding:.75rem 1rem;border-radius:.6rem;" +
      "background:rgba(var(--color-foreground),.05);font-size:1.4rem;line-height:1.4;";
    d.textContent = "No hay artículos con stock para esta búsqueda. " +
      "Te mostramos también los agotados y los de encargo.";
    rejilla.parentNode.insertBefore(d, rejilla);
  }

  document.addEventListener("DOMContentLoaded", function () {
    // SOLO dentro de la rejilla de resultados. La primera version miraba `.card-wrapper`
    // en toda la pagina y la pagina de cero resultados trae una lista de colecciones
    // sugeridas con seis tarjetas: creia que habia resultados y el respaldo no saltaba.
    var rejilla = document.querySelector("#product-grid");
    if (!rejilla) return;                     // tema cambiado: mejor no tocar nada

    if (rejilla.querySelector("li")) {         // hay resultados de verdad
      // si llegamos aqui por haber soltado el filtro, hay que decirlo
      if (paso >= 1 && !par.has("filter.p.m.custom.disponibilidad")) avisoSinStock(rejilla);
      return;
    }

    // LA ESCALERA DE RESPALDO. Cero resultados no siempre significa que no lo tengamos:
    // casi siempre significa que lo tenemos agotado. Caso real (06/09/2026): TZeFX641
    // existe, esta activo y vale 20,18 EUR, pero MuchoCartucho lo dio sin stock esa
    // manana, y como la busqueda filtra por disponible, la ficha desaparecia del todo.
    //
    //   paso 1  quitar el filtro de stock, dejando la busqueda exacta
    //   paso 2  ademas, volver al texto tal cual lo escribio el cliente
    //
    // El contador impide el bucle entre dos paginas vacias.
    if (paso === 0) {
      var habia = quitarFiltroStock(par);
      par.set(VUELTA, "1");
      if (habia) {
        location.replace(location.pathname + "?" + par.toString());
        return;
      }
      // no habia filtro que quitar: se pasa directo al respaldo de siempre
      paso = 1;
    }
    if (paso === 1) {
      quitarFiltroStock(par);
      par.set("q", par.get(MARCA) || par.get("q") || "");
      par.delete(MARCA);
      par.set(VUELTA, "2");
      location.replace(location.pathname + "?" + par.toString());
    }
  });

  var original = par.get(MARCA);
  if (!original) return;

  // 2a) la caja muestra lo que el cliente escribió, no las comillas
  document.addEventListener("DOMContentLoaded", function () {
    var cajas = document.querySelectorAll('form[role="search"] input[name="q"]');
    for (var i = 0; i < cajas.length; i++) cajas[i].value = original;
  });

  // 2b) y el título de la pestaña igual. En la página no se ven las comillas, pero el
  //     título sí las sacaba —«resultados para ""cable" "red" "5m""»— y ese título es el
  //     que se copia al compartir el enlace y el que ve Google.
  var qcomillas = par.get("q");
  if (qcomillas && document.title.indexOf(qcomillas) !== -1) {
    document.title = document.title.replace(qcomillas, original);
  }

  // 2c) si no hay resultados, se repite la búsqueda de siempre. Una sola vez: el
  //     parámetro VUELTA impide que dos páginas vacías se redirijan en bucle.
})();
